import { render, staticRenderFns } from "./wick-guide.vue?vue&type=template&id=05208753&"
import script from "./wick-guide.vue?vue&type=script&lang=js&"
export * from "./wick-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports